const SUPERSEDED_RESULT = Object.freeze({
  ok: false,
  superseded: true,
  error: 'The active account changed while this action completed. The current ledger was left untouched.',
});

/**
 * Serializes server-authoritative wallet/inventory mutations against the
 * offline-progress sync and binds every response to the account that started
 * it. UI pending state remains the caller's responsibility.
 */
export class MutationCoordinator {
  constructor({
    getUserId = () => null,
    flushLedger = async () => true,
    onLedgerReleased = () => {},
  } = {}) {
    this.getUserId = typeof getUserId === 'function' ? getUserId : () => null;
    this.flushLedger = typeof flushLedger === 'function' ? flushLedger : async () => true;
    this.onLedgerReleased = typeof onLedgerReleased === 'function' ? onLedgerReleased : () => {};
    this.activeLedgerKey = null;
  }

  get ledgerActive() {
    return this.activeLedgerKey !== null;
  }

  async run(key, operation, { ledger = false } = {}) {
    if (typeof operation !== 'function') throw new TypeError('Mutation operation must be a function.');
    if (ledger && this.ledgerActive) return { started: false, result: null };

    const requestedUserId = this.getUserId();
    if (ledger) this.activeLedgerKey = key;
    try {
      if (ledger && !(await this.flushLedger())) {
        return { started: true, result: null };
      }
      const result = await operation();
      if (this.getUserId() !== requestedUserId) {
        return { started: true, result: { ...SUPERSEDED_RESULT } };
      }
      return { started: true, result };
    } finally {
      if (ledger && this.activeLedgerKey === key) {
        this.activeLedgerKey = null;
        this.onLedgerReleased();
      }
    }
  }
}
